import React from 'react';
import { Calendar as CalendarComponent, CalendarProps } from 'react-date-range';

const Calendar: React.FC<CalendarProps> = (props) => {
  const LocalCalendar = CalendarComponent as unknown as React.ComponentType<CalendarProps>;

  return <LocalCalendar {...props} />;
};

export default Calendar;
